import { AbstractEntity } from '../AbstractEntity'
import { getCustomsCommodityCodeList } from '@/api/customsCommodityCode'

export class HsCode extends AbstractEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get code() {
    return this._data.code
  }
  set code(code) {
    this._data.code = code
  }
  get commodityName() {
    return this._data.commodityName
  }
  set commodityName(commodityName) {
    this._data.commodityName = commodityName
  }
  get countryCode() {
    return this._data.countryCode
  }
  set countryCode(countryCode) {
    this._data.countryCode = countryCode
  }
  get generalRate() {
    return this._data.generalRate
  }
  set generalRate(generalRate) {
    this._data.generalRate = generalRate || 0
  }
  get legalUnit() {
    return this._data.legalUnit
  }
  set legalUnit(legalUnit) {
    this._data.legalUnit = legalUnit
  }
  get mfnRate() {
    return this._data.mfnRate
  }
  set mfnRate(mfnRate) {
    this._data.mfnRate = mfnRate || 0
  }
  get secondUnit() {
    return this._data.secondUnit
  }
  set secondUnit(secondUnit) {
    this._data.secondUnit = secondUnit
  }
  get superviseMode() {
    return this._data.superviseMode
  }
  set superviseMode(superviseMode) {
    this._data.superviseMode = superviseMode
  }
  get vat() {
    return this._data.vat
  }
  set vat(vat) {
    this._data.vat = vat || 0
  }
  get mscCommodity() {
    return this._data.mscCommodity
  }
  set mscCommodity(mscCommodity) {
    this._data.mscCommodity = mscCommodity
  }
  static async queryHsCode(params) {
    return await getCustomsCommodityCodeList(params).then(res => res.data.list)
  }
}
